import baseAssetNamesToMonitorAtomDefinition from '../atoms/base-asset-names-to-monitor.js';
const createAtomDependencies = () => [
    {
        definition: baseAssetNamesToMonitorAtomDefinition,
    },
];
export default createAtomDependencies;
